export default {
    getSiteData: async function (params) {
        let option = {
            url: '/api/v1/partner/map/allhosts',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getPartnerSetting: async function (params) {
        let option = {
            url: '/api/v1/partner/map/setting',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getAlertContents: async function (params) {
        let option = {
            url: '/api/v1/partner/map/alertcontents',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
}